/**
 * Cleanup for HTML pasted into a Froala editor, called from the
 * `paste.afterCleanup` event.
 *
 * 868m792ww: the earlier version assigned the pasted HTML to a live
 * `document.createElement('span')`. A live element loads its resources, so a
 * payload such as `<img src=x onerror=...>` ran during the cleanup pass.
 * DOMParser builds an inert document, which loads nothing.
 *
 * This function is not a sanitizer. It makes the parse inert and collapses
 * duplicate line breaks. The server strips dangerous markup on write, in
 * com.taxplaniq.utils.HtmlSanitizer.
 */
export function cleanPastedHtml(html: string): string {
  if (!html) {
    return html;
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const children = doc.body.querySelectorAll('*');

  for (let i = 0 ; i < children.length ; i++) {
    if (children[i].tagName === 'BR' && children[i + 1] && children[i + 1].tagName === 'BR') {
      children[i].remove();
    }
  }

  return doc.body.innerHTML;
}
